import { CountryConfigType } from '../../model/CountryConfigType'

const config: CountryConfigType = {
  showSingleCO2Label: true,
  showQuoteSummaryAgreementNotice: true,
  showExtendedPdfQuoteNote: true,
}

export default config
